module.exports = __webpack_public_path__ + "img/index01.e0258b63.png";